/**
 * Most common diagnosis codes for the Treatment Plan template builder select.
 * Includes a few Z codes often used in mental health.
 */
export const TREATMENT_PLAN_COMMON_DIAGNOSES: { code: string; description: string }[] = [
  { code: 'F41.1', description: 'Generalized anxiety disorder' },
  { code: 'F43.23', description: 'Adjustment disorder with mixed anxiety and depressive mood' },
  { code: 'F33.1', description: 'Major depressive disorder, recurrent, moderate' },
  { code: 'F43.22', description: 'Adjustment disorder with anxiety' },
  { code: 'F41.9', description: 'Anxiety disorder, unspecified' },
  { code: 'F43.20', description: 'Adjustment disorder, unspecified' },
  { code: 'F43.10', description: 'Post traumatic stress disorder (PTSD), unspecified' },
  { code: 'F43.12', description: 'Post traumatic stress disorder (PTSD), chronic' },
  { code: 'Z63.0', description: 'Problem in relationship with spouse or partner' },
  { code: 'F43.21', description: 'Adjustment disorder with depressed mood' },
  { code: 'F90.2', description: 'Attention-deficit hyperactivity disorder (ADHD), combined type' },
  { code: 'F33.0', description: 'Major depressive disorder, recurrent, mild' },
  { code: 'F90.0', description: 'Attention-deficit disorder (ADHD), predominantly inattentive type' },
  { code: 'F32.1', description: 'Major depressive disorder, single episode, moderate' },
  { code: 'F34.1', description: 'Dysthymic disorder' },
  { code: 'F84.0', description: 'Autistic disorder' },
  { code: 'F33.2', description: 'Major depressive disorder, recurrent, without psychotic features' },
  { code: 'F32.9', description: 'Major depressive disorder, single episode, unspecified' },
  { code: 'Z71.3', description: 'Dietary counseling and surveillance' },
  { code: 'F90.9', description: 'Attention deficit hyperactivity disorder (ADHD), unspecified type' },
];
